import { excludedTaxRates } from '../constants/excludedTaxRates';
import { ProductClassesData, TaxData, TaxesData } from '../types/location';
import { Enum, SelectInputOption } from '../types/sharedTypes';
import { formatNumberPercentage, formatNumberPrice } from './validation';

export const parseEnumValuesToOptions = (e: Enum): SelectInputOption[] => {
  return Object.values(e).map((item) => {
    return { value: item, label: item };
  });
};

export const getOptionsByKeys = (e: Enum): SelectInputOption[] => {
  return Object.keys(e).map((item) => {
    return { value: item, label: item };
  });
};

export const parseEnumToSelectOption = (enumObj: Enum): SelectInputOption[] => {
  return Object.entries(enumObj).map(([label, value]) => ({ label, value }));
};

export function convertArrayToSelectOptions(arr: string[]) {
  return arr.map((item) => {
    return { value: item, label: item };
  });
}

export function convertProductClassesToSelectOptions(arr: ProductClassesData) {
  const data = arr?.data || [];
  if (!Array.isArray(data)) {
    return [];
  }
  return data.reduce((options, item) => {
    if (!excludedTaxRates.includes(item.attributes.name)) {
      options.push({
        value: item.attributes.slug,
        label: item.attributes.name,
      });
    }
    return options;
  }, [] as { value: string; label: string }[]);
}

export function parseTaxesDataForDisplayInTaxesForm(taxesData: TaxesData) {
  return taxesData?.data
    ?.filter((tax) => !excludedTaxRates.includes(tax.product_class_name))
    .map((rate) => {
      return {
        ...rate,
        tax_rate: formatNumberPercentage(rate.tax_rate),
        min_applicable:
          rate.min_applicable === ''
            ? undefined
            : formatNumberPrice(rate.min_applicable),
        max_applicable:
          rate.max_applicable === ''
            ? undefined
            : formatNumberPrice(rate.max_applicable),
      };
    }) as TaxData[];
}

export function convertLabelToSlug(label: string) {
  return label?.toLowerCase().replace(/\s+/g, '');
}
